export default __webpack_public_path__ + "b775491248cd3548e18819bf86990094.png";